import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router, NavigationEnd, RouterModule } from '@angular/router';
import { filter, map } from 'rxjs';
import { toSignal } from '@angular/core/rxjs-interop';
import { UserDefinitionService } from '@services/user-definition.service';
import { IUser } from '@shared/interfaces/user-definitions.interface';

@Component({
    selector: 'app-header',
    standalone: true,
    imports: [CommonModule, RouterModule],
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.scss']
})
export class HeaderComponent {
    private router = inject(Router);
    private userService = inject(UserDefinitionService);

    private pageNames: Record<string, string> = {
        reports: 'Reports',
        definitions: 'Access Management',
        cms: 'Landing Page',
        parameters: 'Parameters',
        'payment-definitions': 'Payment Definitions',
        dashboard: 'Dashboard'
    };

    readonly currentPage = toSignal(
        this.router.events.pipe(
            filter((e) => e instanceof NavigationEnd),
            map((e: any) => {
                const seg = e.urlAfterRedirects.split('/')[1] || 'dashboard';
                return this.pageNames[seg] ?? 'Dashboard';
            })
        ),
        { initialValue: 'Dashboard' }
    );

    readonly userInfo = toSignal<IUser | null>(this.userService.$userInfo.asObservable(), { initialValue: null });
}
